export default function createOpportunity() {
    return {
        id: null,
        name: null,
        status: {
            id: null,
            name: null,
            isWon: null,
            backgroundClass: null,
        },
        statusColor: null,
        description: null,
        netAmount: null,
        type: {
            id: null,
            name: null,
        },
        registeredDeals: [],
        files: [],
        contact: null,
        secondaryContacts: [],
        company: null,
        salesperson: {},
        salespersons: [],
        priceType: null,
        priceDuration: 0,
        price: null,
        pricingDetails: 'simple',
        cost: null,
        total: null,
        yearly: null,
        upfront: null,
        grossMargin: {
            amount: 0,
            percentage: 0
        },
        discount: null,
        discountUnit: null,
        discountAmount: null,
        discountPercentage: null,
        isApproved: false,
        simpleEntry: {
            priceType: {
                id: null,
                name: 'Fixed bid',
            },

            duration: null,
            price: null,
            cost: null,
            discount: null,
            discountType: 'percentage',
            totalPrice: 0,
            totalCost: 0,
        },
        itemizedEntry: {
            upfrontPayment: null,
            annualPayment: null,
            hasDiscount: false,
            discountType: 'total',
            itemDiscountValue: 10,
            itemDiscountType: 'percentage',

            totalDiscountValue: 10,
            totalDiscountType: 'percentage',

            solutions: [],
            totalPrice: 0,
            totalCost: 0,
            
            price: null,
        },
    };
}